import { useState, useEffect } from 'react';

export default function WhatsAppButton() {
  const [show, setShow] = useState(false);
  const [showLabel, setShowLabel] = useState(false);

  useEffect(() => {
    // Appear after 1.5s
    const t1 = setTimeout(() => setShow(true), 1500);
    // Show label after 3s
    const t2 = setTimeout(() => setShowLabel(true), 3000);
    // Hide label after 7s
    const t3 = setTimeout(() => setShowLabel(false), 7000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-4 md:right-6 z-50 flex items-center gap-3 transition-all duration-500 ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
    >
      {/* Label bubble */}
      <div
        className={`bg-white rounded-xl px-4 py-2.5 text-sm font-semibold text-gray-800 transition-all duration-300 whitespace-nowrap ${showLabel ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'}`}
        style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.12)' }}
      >
        <span className="block text-xs text-gray-500 font-normal">Need help?</span>
        Chat with us on WhatsApp
      </div>

      {/* Button */}
      <a
        href="https://wa.me/8617671262710"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp us"
        className="relative flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 active:scale-95 text-white rounded-full cursor-pointer transition-all duration-200"
        style={{ boxShadow: '0 4px 20px rgba(37,211,102,0.4)' }}
        onMouseEnter={() => setShowLabel(true)}
        onMouseLeave={() => setShowLabel(false)}
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-30" />
        <i className="ri-whatsapp-line text-2xl relative z-10" />
      </a>
    </div>
  );
}
